import { createDefinition } from '@atlassiansox/bxp-definition-sdk';
import { versionDefinitionV0 } from './versions/v0/version-definition';

export default createDefinition({
  name: 'adminTrialCart',
  schema: '0.1.0',
  type: 'module', // options: module | field | surface | zone
  versions: {
    0: versionDefinitionV0
  }
});
